/**
 *
 */
define('common/config/services',{

    /**
     * Stubbed services
     */

    MessageAlert: {},

    actionProvider: {},

    frameworkApp: {},

    gameLauncher: {},

    globalCommandListener: {},

    itemManager: {},

    gamesInterface: {},

    emailVerificationDisplay: {},

    /**
     * Local Storage Accessors
     */
    abTestingStorage: {
        factoryService: 'localStorageAccessorFactory',
        args: ['%localStorageKeys.testSubjectId']
    },

    debugModeEnabledFlag: {
        factoryService: 'localStorageAccessorFactory',
        args: ['%localStorageKeys.debugModeEnabled']
    },

    showDisabledGamesFlag: {
        factoryService: 'localStorageAccessorFactory',
        args: ['%localStorageKeys.showDisabledGames']
    },

    tournamentCampaignOverride: {
        factoryService: 'localStorageAccessorFactory',
        args: ['%localStorageKeys.tournamentCampaignOverride']
    },

    gameLauncherStrategyOverride: {
        factoryService: 'localStorageAccessorFactory',
        args: ['%localStorageKeys.gameLauncherStrategyOverride']
    },

    adventureOverride: {
        factoryService: 'localStorageAccessorFactory',
        args: ['%localStorageKeys.adventureOverride']
    },

    /**
     * Feature: emailVerification
     */
    EmailVerificationViewModel: {
        module: 'common/features/emailVerification/EmailVerificationViewModel',
        init: 'partial',
        args: [
            '@session',
            'PlatformCmd:resend-verification-code:common',
            'PlatformCmd:logout:common',
            'fe:wp:page:root:mobile/verify-email',
            '%emailVerificationViewUrl'
        ]
    },

    PlayerEmailVerification: {
        module: 'common/features/emailVerification/PlayerEmailVerification',
        init: 'partial',
        args: ['subscriptionManager'],
        extras: [
            {
                cometd: {
                    path: 'emailVerifiedEvent',
                    subscribeTo: 'subscribeToPlayer',
                    subscribeToId: 'playerId',
                    methodName: 'handleEmailVerifiedEvent',
                    initialise: false
                }
            }
        ]
    },

    emailVerification: {
        module: 'common/features/emailVerification/EmailVerification',
        args: [
            '@session',
            '@navigation',
            '@emailVerifier',
            '@emailVerificationDisplay',
            'PlatformCmd:logout:common'
        ],
        extras: [
            {
                subscribe: {
                    onAppComposed: 'showEmailVerificationIfNeeded',
                    onLogin: 'showEmailVerificationIfNeeded',
                    onRegistration: 'showEmailVerificationIfNeeded'
                }
            }
        ]
    },

    emailVerifier: {
        module: 'common/features/emailVerification/EmailVerifier',
        args: [
            '@session',
            'PlatformCmd:verify-email:common'
        ]
    },

    /**
     * Model
     */

    Adventure: {
        module: 'common/domain/adventurer/Adventure',
        init: 'partial',
        args: [
            'LOG',
            '@EarnedAchievement',
            '@EarnedItem',
            '@Location',
            'Query:common:gamification/adventure',
            '@cometd',
            '@gameRoundDelay',
            'defer:@gameLauncher',
            'defer:@session',
            '@spaceCrystals',
            '@quests',
            '@achievements',
            '%versionedLevelPoints',
            'publish:adventureLoaded'
        ]
    },

    Adventurer: {
        module: 'common/domain/adventurer/Adventurer',
        init: 'partial',
        args: [
            '@Adventure',
            'Query:common:gamification/adventurer',
            '@cometd',
            '@casumos',
            '@vocabulary'
        ]
    },

    DesktopGame: {
        module: 'common/domain/games.DesktopGame',
        init: 'partial',
        args: [
            '@context',
            '@settings',
            '@actionProvider',
            '@achievements',
            '@jackpots',
            '@gameProviders',
            'wp:page:root:game'
        ]
    },

    EarnedAchievement: {
        module: 'common/domain/adventurer/EarnedAchievement',
        init: 'partial',
        args: ['@achievements']
    },

    EarnedItem: {
        module: 'common/domain/adventurer/EarnedItem',
        init: 'partial',
        args: [
            '@Command',
            '@PlatformCommandDispatcher',
            '@context',
            '@itemTemplates',
            '@evaluateDynamicText',
            '@itemTools'
        ]
    },

    GameProviderModel: {
        module: 'common/gameProviders/GameProviderModel',
        init: 'partial',
        args: ['LOG', '@durandal/app']
    },

    Location: {
        module: 'common/model/Location',
        init: 'partial',
        args: ['@planets']
    },

    MobileGame: {
        module: 'common/domain/games.MobileGame',
        init: 'partial',
        args: [
            '@context',
            '@settings',
            '@actionProvider',
            '@achievements',
            '@jackpots',
            '@gameProviders',
            'wp:page:root:mobile-game'
        ]
    },

    Notification: {
        module: 'common/model/Notification',
        init: 'partial',
        args: ['@notificationTemplates']
    },

    Notifications: {
        module: 'common/Notifications',
        init: 'partial',
        args: [
            'LOG',
            '@Command',
            '@PlatformCommandDispatcher',
            '@ReceivedNotification',
            '@cometd',
            '@gameRoundDelay',
            'defer:@gameLauncher'
        ]
    },

    PaymentTransaction: {
        module: 'common/domain/player/PaymentTransaction',
        init: 'partial',
        args: ['@Command', '@PiqCommandDispatcher']
    },

    Payments: {
        module: 'common/domain/player/Payments',
        init: 'partial',
        args: [
            '@paymentMethods',
            '@PaymentTransaction',
            '@cometd',
            '@Query',
            'Query:common:paymentMethodTypes'
        ]
    },

    RealityCheckViewModel: {
        module: 'common/features/realityCheck/RealityCheckViewModel',
        init: 'partial',
        args: [
            'wp:page:root:shared/reality-check',
            '@session.player',
            'PlatformCmd:changeRealityCheckInterval:common'
        ]
    },

    Tournament: {
        module: 'common/model/tournaments/Tournament',
        init: 'partial',
        args: [
            '@settings',
            '@itemTemplates',
            '@gamesInterface',
            'publish:onTournamentFinished'
        ],
        extras: [
            {
                cometd: [
                    {
                        path: 'tournaments/tournamentProperties/status',
                        subscribeTo: 'subscribeToPublic',
                        methodName: 'handleStatusUpdate'
                    }, {
                        path: 'tournaments/tournamentEvents/finished',
                        subscribeTo: 'subscribeToPublic',
                        methodName: 'handleTournamentFinished'
                    }
                ]
            }
        ]
    },

    TournamentLeaderboard: {
        module: 'common/model/tournaments/TournamentLeaderboard',
        init: 'return'
    },

    TournamentLeaderboardEntry: {
        module: 'common/model/tournaments/TournamentLeaderboardEntry',
        init: 'partial',
        args: [
            '@games',
            '@adventurers'
        ]
    },

    TournamentCampaign: {
        module: 'common/model/tournaments/TournamentCampaign',
        init: 'partial',
        args: ['@gamesInterface'],
        extras: [
            {
                cometd: {
                    path: 'tournaments/tournamentEvents/scheduled',
                    subscribeTo: 'subscribeToPublic',
                    methodName: 'handleTournamentScheduled'
                }
            }
        ]
    },

    PlayerTournament: {
        module: 'common/model/tournaments/PlayerTournament',
        init: 'partial',
        args: [
            '@Tournament',
            'PlatformCmd:enterTournament:common',
            '@PlayerTournamentLeaderboard'
        ],
        extras: [
            {
                cometd: {
                    path: 'tournaments/players/<%= playerId %>/tournamentEvents/entered',
                    subscribeTo: 'subscribeToPublic',
                    methodName: 'handleTournamentEntered'
                }
            }
        ]
    },

    PlayerTournamentLeaderboard: {
        module: 'common/model/tournaments/PlayerTournamentLeaderboard',
        init: 'partial',
        args: [
            '@TournamentLeaderboard',
            '@PlayerTournamentLeaderboardEntry'
        ]
    },

    PlayerTournamentLeaderboardEntry: {
        module: 'common/model/tournaments/PlayerTournamentLeaderboardEntry',
        init: 'partial',
        args: ['@TournamentLeaderboardEntry']
    },

    LeaderboardUpdateHandler: {
        module: 'common/model/tournaments/LeaderboardUpdateHandler',
        init: 'partial',
        args: ['@gameRoundDelay'],
        extras: [
            {
                cometd: [
                    {
                    /*eslint-disable max-len */
                        path: 'tournaments/players/<%= playerId %>/tournaments/<%= tournamentId %>/leaderboard',
                        subscribeTo: 'subscribeToPublic',
                        methodName: 'handleEntriesUpdate',
                        initialise: false
                    }, {
                        path: 'tournaments/tournaments/<%= tournamentId %>/leaderboard/<%= playerId %>',
                        subscribeTo: 'subscribeToPublic',
                        methodName: 'handlePlayerEntryUpdate',
                        initialise: false
                    }
                    /*eslint-enable max-len */
                ]
            }
        ]
    },

    subscribeToLeaderboardUpdates: {
        module: 'common/model/tournaments/subscribeToLeaderboardUpdates',
        init: 'partial',
        args: [
            '@LeaderboardUpdateHandler',
            'subscriptionManager'
        ]
    },

    sessionPlayerTournamentCampaign: {
        module: 'common/model/tournaments/createPlayerTournamentCampaign',
        args: [
            '@PlayerTournamentCampaign',
            '@session.player'
        ]
    },

    PlayerTournamentCampaign: {
        module: 'common/model/tournaments/PlayerTournamentCampaign',
        init: 'partial',
        args: [
            '@PlayerTournament',
            '@TournamentCampaign'
        ]
    },

    Player: {
        module: 'common/utils/createModularConstructor',
        args: [
            '@BasePlayer',
            '@playerModules'
        ]
    },

    playerModules: {
        structuredArg: {
            emailVerification: '@PlayerEmailVerification'
        }
    },

    BasePlayer: {
        module: 'common/domain/player/Player',
        init: 'partial',
        args: [
            '@internationalization',
            '@referrerInfo',
            '@adventurers',
            '@Notifications',
            '@Payments',
            '@PlayOkayModel',
            '@Query',
            '@gameRoundDelay',
            '@context',
            '@cometd'
        ]
    },

    PlayOkayModel: {
        module: 'common/model/PlayOkay',
        init: 'partial',
        args: [
            '@cometd',
            'Query:common:playok'
        ]
    },

    ReceivedNotification: {
        module: 'common/model/ReceivedNotification',
        init: 'partial',
        args: ['@Command', '@PlatformCommandDispatcher', '@notificationTemplates']
    },

    achievements: {
        module: 'common/cms/Achievements',
        args: ['LOG', '@vocabulary', '@wp', '@evaluateDynamicText', 'wp:cmf:root:achievement']
    },

    adventurers: {
        module: 'common/domain/adventurer/Adventurers',
        args: ['@Adventurer', '@Query']
    },

    campaigns: {
        module: 'common/cms/Campaigns',
        args: [
            '@settings',
            '@pageModules',
            '@welcomeOffers',
            'wp:cmf:market:registration-promotions',
            'wp:cmf:market:campaigns'
        ]
    },

    casumos: {
        module: 'common/cms/Casumos',
        args: ['wp:cmf:root:adventure/casumos']
    },

    cmsMandatoryMessages: {
        module: 'common/cms/MandatoryMessages',
        args: ['@evaluateDynamicText', 'wp:page:root:mandatory-messages']
    },

    desktopGameMapper: {
        factoryService: 'wp.makeConstructorMapper',
        args: ['wp:page:root:game', '@DesktopGame']
    },

    faker: {
        module: 'common/faker',
        init: 'factory',
        args: ['@cometd', '@session', '@context', '@gameRoundDelay']
    },

    gameProviders: {
        module: 'common/domain/GameProviders',
        args: ['@Query', '@cometd', '@session']
    },

    maintenancePaymentMethods: {
        module: 'common/domain/PaymentMethods',
        args: ['@Query', '@cometd', '@session']
    },

    gameRoundDelay: {
        module: 'common/GameRoundDelay',
        args: ['defer:@gameLauncher'],
        extras: [
            {
                subscribe: {
                    'GAME:ROUND:ENDED': 'endWait'
                }
            }
        ]
    },

    games: {
        module: 'common/domain/games.Games',
        args: ['@wp', '@desktopGameMapper', '@mobileGameMapper', 'LOG', '@context']
    },

    gameRounds: {
        module: 'common/gameRoundsHistory/GameRounds',
        args: ['@Query', '@games', 'fe:wp:page:root:shared/game-providers']
    },

    internationalization: {
        module: 'common/Internationalization',
        args: ['defer:@vocabulary']
    },

    itemImageGenerator: {
        module: 'common/ItemImageGenerator',
        args: [
            'LOG',
            '%images.freeSpinSpriteImage',
            '%images.depositBonusImage',
            '%images.moneyImage',
            '%images.funinatorImage'
        ]
    },

    itemTemplates: {
        module: 'common/cms/ItemTemplates',
        args: [
            'defer:@games',
            '@vocabulary',
            '@evaluateDynamicText',
            'wp:cmf:root:item',
            '@wp',
            '@itemImageGenerator',
            '@itemTools'
        ]
    },

    itemTools: {
        module: 'common/ItemTools'
    },

    jackpots: {
        module: 'common/Jackpots',
        args: ['Query:common:jackpots', '@cometd', '@settings']
    },

    leaderboards: {
        module: 'common/cms/Leaderboards',
        args: ['defer:@session', '@Query', '@cometd']
    },

    miscAdventure: {
        module: 'common/cms/MiscAdventure',
        args: ['wp:page:root:adventure']
    },

    mobileGameMapper: {
        factoryService: 'wp.makeConstructorMapper',
        args: ['wp:page:root:mobile-game', '@MobileGame']
    },

    notificationTemplates: {
        module: 'common/cms/NotificationTemplates',
        args: ['@evaluateDynamicText', 'defer:@session', 'wp:page:root:notifications']
    },

    offerSelector: {
        module: 'common/OfferSelector',
        args: ['@campaigns', '@settings']
    },

    pageModules: {
        module: 'common/cms/PageModules',
        args: ['wp:cmf:root:page-modules']
    },

    paymentMethods: {
        module: 'common/cms/PaymentMethods',
        args: ['LOG', '@context', '@settings', '@wp', 'wp:cmf:root:payment-method']
    },

    planets: {
        module: 'common/cms/Planets',
        args: ['wp:cmf:root:planets', 'wp:cmf:root:places']
    },

    players: {
        module: 'common/domain/player/Players',
        args: [
            'LOG',
            '@Player',
            '@Query',
            '@internationalization',
            '%preLoadedPlayers'
        ]
    },

    questChooser: {
        module: 'common/model/QuestChooser',
        args: ['@session', 'PlatformCmd:chooseQuest:common']
    },

    quests: {
        module: 'common/cms/Quests',
        args: [
            'defer:@session',
            '@achievements',
            '@itemTemplates',
            '@leaderboards',
            'Query:common:achievementProgress/quests',
            'Query:common:quests/previous',
            'wp:page:root:achievement',
            '@wp'
        ]
    },

    referrerInfo: {
        module: 'common/model/ReferrerInfo',
        args: ['cookieAccessor:referrerInfo']
    },

    rawSession: {
        module: 'common/Session',
        args: [
            'LOG',
            '@cometd',
            'publish:onLogout',
            '%sessionState'
        ]
    },

    session: {
        module: 'common/PlayerSession',
        args: [
            '@rawSession',
            '@cometd',
            '@players',
            'publish:onLogin'
        ]
    },

    sessionPlayerPublisher: {
        module: 'common/sessionPlayerPublisher',
        init: 'partial',
        args: [
            '@session',
            'publish:onSessionPlayer'
        ],
        extras: [
            {
                subscribe: 'afterAppStart'
            }
        ]
    },

    sessionToucher: {
        module: 'common/SessionToucher',
        args: ['PlatformCmd:touch:common'],
        extras: [
            {
                subscribe: {
                    'afterAppStart': 'start'
                }
            }
        ]
    },

    settings: {
        module: 'common/Settings',
        args: [
            'LOG',
            '@internationalization',
            'cookieAccessor:actionedPageModule',
            'cookieAccessor:marketCode',
            'cookieAccessor:preSelectedWelcomeOfferId',
            'cookieAccessor:selectedWelcomeOfferId',
            'cookieAccessor:targetCampaignId',
            'defer:@session',
            '@abTesting',
            '@context',
            'publish:marketSet'
        ]
    },

    spaceCrystals: {
        module: 'common/cms/SpaceCrystalCollections',
        args: ['@vocabulary']
    },

    startMandatoryMessages: {
        module: 'common/startMandatoryMessages',
        init: 'partial',
        args: [
            '@Command',
            '@PlatformCommandDispatcher',
            '@session',
            '@cometd',
            '@plugins/dialog',
            '@cmsMandatoryMessages',
            '@MessageAlert'
        ],
        extras: [
            {
                subscribe: 'afterAppStart'
            }
        ]
    },

    welcomeOffers: {
        module: 'common/cms/WelcomeOfferGroups',
        args: ['@context', '@itemTemplates', '@wp', 'wp:page:root:offers/welcome-offers']
    },

    /**
     * Platform
     */
    Command: {
        module: 'common/Command',
        init: 'partial',
        args: ['LOG', '@globalCommandListener']
    },

    PiqCommandDispatcher: {
        module: 'common/payment/PiqCommandDispatcher',
        init: 'partial',
        args: ['LOG', 'defer:@session', '@googleTagManager', '@piqApi']
    },

    PlatformCommandDispatcher: {
        module: 'common/PlatformCommandDispatcher',
        init: 'partial',
        args: ['@context']
    },

    PlatformCommandDispatcherAPlus: {
        module: 'common/PlatformCommandDispatcher.APlus',
        init: 'partial',
        args: ['@context']
    },

    Query: {
        module: 'common/createQueryConstructor',
        init: 'factory',
        args: ['LOG', '@context']
    },

    abTesting: {
        module: 'common/ABTesting',
        args: [
            '@Command',
            '@PlatformCommandDispatcher',
            '@abTestingStorage',
            'LOG',
            'publish:testSubjectIdSet',
            'publish:testStarted'
        ],
        extras: [
            {
                subscribe: {
                    'beforeAppStart': 'initialize'
                }
            }
        ]
    },

    cometd: {
        module: 'common/Cometd',
        args: [
            'LOG',
            '@context',
            'defer:@session',
            '@jquery/cometd',
            '%cometUrl'
        ],
        extras: [
            {
                subscribe: {
                    'beforeAppStart': 'initialize',
                    'onDOMUnload': 'uninitialize'
                }
            }
        ]
    },

    context: {
        module: 'common/Context',
        args: ['%contextConfiguration']
    },

    domEvents: {
        module: 'common/DOMEvents',
        args: [
            'publish:onDOMUnload',
            'publish:onDOMMessage'
        ],
        extras: [
            {
                subscribe: {
                    onAppInit: 'initialise'
                }
            }
        ]
    },

    absoluteUrls: {
        module: 'common/config/AbsoluteUrls',
        args: [
            '%urls'
        ]
    },

    piqApi: {
        module: 'common/payment/PiqApi',
        args: ['%piqConfig', 'defer:@session', '@Query', '%piqChannel']
    },

    piqCryptoUtils: {
        module: 'common/payment/PiqCryptoUtils',
        args: ['%piqConfig']
    },

    trackAppInfo: {
        module: 'common/trackAppInfo',
        init: 'partial',
        args: ['cookieAccessor:appInfo', '%appType'],
        extras: [
            {
                subscribe: 'onAppInit'
            }
        ]
    },

    trackDeviceInfo: {
        module: 'common/trackDeviceInfo',
        args: ['@context', 'cookieAccessor:deviceInfo', 'cookieAccessor:fingerprintV2'],
        extras: [
            {
                subscribe: {
                    'beforeAppStart': 'initialize'
                }
            }
        ]
    },

    /**
     * CMS
     */
    WPContentRequester: {
        module: 'common/cms/WPContentRequester',
        init: 'partial',
        args: ['@context', '@settings', '@Query']
    },

    WPInterface: {
        module: 'common/cms/WPInterface',
        init: 'partial',
        args: ['LOG', '%cms.overrides']
    },

    contentPreloader: {
        module: 'common/contentPreloader',

        args: ['@session', '@wp', '%preloadContent'],
        extras: [
            {
                subscribe: {
                    beforeAppStart: 'preloadInitialContent',
                    onLogin: 'preloadLoggedInContent',
                    onRegistration: 'preloadLoggedInContent'
                }
            }
        ]
    },

    evaluateDynamicText: {
        module: 'common/utils/lazyFunction',
        init: 'partial',
        args: ['defer:@evaluateDynamicTextUnsafe', '%emptyString']
    },

    evaluateDynamicTextExports: {
        module: 'common/cms/createDynamicTextExports',
        init: 'factory',
        args: ['@session', '@achievements', '@spaceCrystals', '@miscAdventure']
    },

    evaluateDynamicTextUnsafe: {
        module: 'common/cms/evaluateDynamicText',
        init: 'partial',
        args: ['LOG', '@context', '@evaluateDynamicTextExports']
    },

    vocabulary: {
        module: 'common/vocabulary/Vocabulary',
        args: ['@evaluateDynamicText', '@vocabularyResolver', 'wp:page:root:translations']
    },

    vocabularyResolver: {
        module: 'common/vocabulary/CompositeVocaResolver',
        args: ['LOG', '@settings', '@internationalization', '@vocabularyResolvers']
    },

    vocabularyResolvers: {
        module: 'common/vocabulary/createVocaResolvers',
        init: 'factory',
        args: [
            'LOG',
            'defer:@campaigns',
            'wp:page:root:translations',
            'wp:page:root:mobile-game',
            'wp:page:root:game'
        ]
    },

    wp: {
        module: 'common/cms/WPInterfaceResolver',
        args: [
            'LOG',
            '@cometd',
            '@settings',
            '@internationalization',
            '@WPContentRequester',
            '@WPInterface',
            '%cms.hashes'
        ]
    },

    /**
     * Framework
     */
    Logger: {
        module: 'common/Logger',
        init: 'partial',
        args: ['@context', '@newRelicLogger']
    },

    navigation: {
        module: 'common/Navigation',
        args: [
            'LOG',
            '@plugins/router',
            '@plugins/history',
            '@settings',
            '@internationalization',
            '@routeUtils',
            '%routeIds',
            'publish:onNavigation'
        ],
        extras: [
            {
                subscribe: {
                    onDOMMessage: 'handleDOMMessage'
                }
            }
        ]
    },

    // @todo Is this actually used in site?
    PageHead: {
        module: 'common/durandal/PageHead',
        init: 'partial',
        args: [
            '@context',
            '@navigation',
            '@internationalization',
            '@routeUtils',
            '@settings'
        ]
    },

    app: {
        module: 'common/app',
        init: 'factory',
        args: [
            '@frameworkApp',
            'publish:onAppInit',
            'publish:beforeAppStart',
            'publish:afterAppStart'
        ]
    },

    createCookieAccessor: {
        module: 'common/createCookieAccessor',
        init: 'return'
    },

    googleTagManager: {
        module: 'common/GoogleTagManager',
        args: [
            '@context',
            '@referrerInfo',
            'defer:@session',
            'defer:@abTesting',
            '%googleTagManagerId'
        ],
        extras: [{
            subscribe: {
                onAppComposed: 'initialize',
                onLogin: 'trackLogin',
                onLogout: 'trackLogout'
            }
        }]
    },

    handleOverrides: {
        module: 'common/handleOverrides',
        init: 'partial',
        args: ['@context', '@debugModeEnabledFlag', '@showDisabledGamesFlag'],
        extras: [
            {
                subscribe: 'onAppInit'
            }
        ]
    },

    heatMapRecorder: {
        module: 'common/HeatMapRecorder',
        args: ['%heatMapRecorderId']
    },

    interceptAcquire: {
        module: 'common/ko/interceptAcquire',
        init: 'partial',
        args: ['@durandal/system', 'container'],
        extras: [
            {
                subscribe: 'onAppInit'
            }
        ]
    },

    localStorageAccessorFactory: {
        module: 'common/createLocalStorageAccessorFactory',
        args: ['LOG']
    },

    newRelicLogger: {
        module: 'common/NewRelicLogger'
    },

    mixpanel: {
        module: 'common/mixpanel/Mixpanel',
        args: [
            'LOG',
            '@mixpanelInit',
            '@offerSelector',
            '@abTesting',
            'cookieAccessor:numberOfVisits',
            'cookieAccessor:startedRegistration'
        ],
        extras: [
            {
                subscribe: {
                    viewedFrontPageModule: 'viewedFrontPageModule',
                    campaignIdSet: 'campaignIdSet',
                    testSubjectIdSet: 'testSubjectIdSet',
                    onLogin: 'onLogin',
                    testStarted: 'testStarted',
                    marketSet: 'marketSet',
                    chatStatusChanged: 'chatStatusChanged',
                    offerSet: 'offerSet',
                    adventurerLevelSet: 'adventurerLevelSet',
                    gameBrowserTabChanged: 'gameBrowserTabChanged',
                    cashOverlayTabChanged: 'cashOverlayTabChanged',
                    paymentMethodSelected: 'paymentMethodSelected',
                    historyTabSelected: 'historyTabSelected',
                    loginBoxShown: 'loginBoxShown',
                    adventureLoaded: 'adventureLoaded',
                    activeAdventureTabScreenSet: 'activeAdventureTabScreenSet',
                    userAreaTabChanged: 'userAreaTabChanged',
                    faqPageActivated: 'faqPageActivated',
                    cmsPageActivated: 'cmsPageActivated',
                    footerScrolledInView: 'footerScrolledInView',
                    registrationStarted: 'registrationStarted',
                    registrationFieldChanged: 'registrationFieldChanged',
                    tournamentCardStateChanged: 'tournamentCardStateChanged',
                    gameModeChanged: 'gameModeChanged',
                    depositBonusViewStateChanged: 'depositBonusViewStateChanged',
                    ABTestingReady: 'ABTestingReady',
                    onAppComposed: 'onAppComposed',
                    onLogout: 'onLogout',
                    frontPageRegFormSubmitted: 'frontPageRegFormSubmitted',
                    registrationStateSet: 'registrationStateSet',
                    registrationStep1FormSubmitted: 'registrationStep1FormSubmitted',
                    mixpanelOnRegistration: 'onRegistration'

                }
            }
        ]
    },

    mixpanelInit: {
        module: 'common/mixpanel/MixpanelInit',
        args: [
            'LOG',
            '%mixPanelToken'
        ],
        extras: [
            {
                subscribe: {
                    onAppComposed: 'initialize'
                }
            }
        ]
    },

    routeGuards: {
        module: 'common/durandal/NiftyRouteGuards',
        args: [
            'LOG',
            '@internationalization',
            '@settings',
            '@session',
            '@routeUtils',
            '@navigation',
            'publish:showDialog',
            'publish:navigate.screen'
        ]
    },

    routeUtils: {
        module: 'common/durandal/RouteUtils',
        args: ['@internationalization']
    },

    snapshotRenderHelper: {
        module: 'common/seo/snapshotRenderHelper',
        extras: [
            {
                subscribe: {
                    onAppInit: 'disallowSnapshot',
                    onAppComposed: 'allowSnapshot'
                }
            }
        ]
    },

    wireNonStaticDependencies: {
        module: 'common/ko/wireNonStaticDependencies',
        init: 'partial',
        args: ['@context', '@Logger', '@settings'],
        extras: [
            {
                subscribe: 'onAppInit'
            }
        ]
    },

    /**
     * Overridden statics
     */
    'plugins/widget': {
        module: 'common/durandal/widget',
        init: 'return'
    },

    /**
     * Statics
     */
    'durandal/activator': {
        module: 'durandal/activator',
        init: 'return'
    },

    'durandal/app': {
        module: 'durandal/app',
        init: 'return'
    },

    'durandal/binder': {
        module: 'durandal/binder',
        init: 'return'
    },

    'durandal/system': {
        module: 'durandal/system',
        init: 'return'
    },

    'durandal/viewLocator': {
        module: 'durandal/viewLocator',
        init: 'return'
    },

    'jquery/cometd': {
        module: 'jquery/cometd',
        init: 'return'
    },

    'plugins/dialog': {
        module: 'plugins/dialog',
        init: 'return'
    },

    'plugins/history': {
        module: 'plugins/history',
        init: 'return'
    },

    'plugins/router': {
        module: 'plugins/router',
        init: 'return'
    }

});

